import React, {useState, useEffect} from 'react'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import {ViewLetter} from '../../../components/Letter/ViewLetter'

const Test = () => {
  const [show, setShow] = useState(false)

  const handleClose = () => setShow(false)
  const handleShow = () => setShow(true)

  return (
    <div className='card'>
      <div className='card-body'>
        <Button variant='primary' onClick={handleShow}>
          Launch demo modal
        </Button>

        <Modal
          show={show}
          onHide={handleClose}
          size='xl'
          backdrop='static'
          keyboard={false}
          scrollable
        >
          <Modal.Header closeButton>
            <Modal.Title>View Letter</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <ViewLetter type='sip' />
          </Modal.Body>
        </Modal>
      </div>
    </div>
  )
}

export {Test}
